module.exports = __webpack_public_path__ + "static/media/vepormas.71529a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/vepormas.png
// module id = 739
// module chunks = 0